import { getCurrentColor } from "../../constants";
import SelectSort from "../Select/SelectSort";

import BreadcrumbCustom from "../BreadcrumbCustom/BreadcrumbCustom";

import {
  Box,
  Flex,
  Heading,
  Skeleton,
  Switch,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useAtom } from "jotai";
import {
  allProductsAtom,
  productsLoadingStatusAtom,
  caliberCountAtom,
} from "../../atom/products";

import {
  allProductsAtom as allListingsAtom,
  categoriesPageModeAtom,
  productsLoadingStatusAtom as listingsLoadingStatusAtom,
} from "../../atom/listings";
import ItemInfoMobile from "../ItemInfo/ItemInfoMobile";
import {
  atttibutesAtom,
  allProductsAtom as groupListingsAllProducts,
} from "../../atom/groupListings";
import { useEffect, useState } from "react";
import { fetchProductSEOAtom, productSEOAtom } from "../../atom/productSEO";
import { caliberSEOAtom, fetchCaliberSEOAtom } from "../../atom/caliberSEO";
import {
  brandCaliberSEOAtom,
  fetchBrandCaliberSEOAtom,
} from "../../atom/brandCaliberSEO";

const InfoOnProductsPage = ({ slider, locationState, setCustomHTML }) => {
  const location = useLocation();
  const { colorMode } = useColorMode();
  const [categoriesPageMode, setCategoriesPageMode] = useAtom(
    categoriesPageModeAtom,
  );
  const [productAttributes] = useAtom(atttibutesAtom);

  const keywords = [
    "rifle-ammo",
    "handgun-ammo",
    "shotgun-ammo",
    "rimfire-ammo",
  ];

  const pathSegments = location.pathname.split("/").filter(Boolean);

  const calibers = pathSegments[1];

  const handleCategoriesPageModeToggle = () => {
    const newMode = categoriesPageMode === "listings" ? "products" : "listings";
    setCategoriesPageMode(newMode);
    localStorage.setItem("categoriesPageMode", newMode);
  };

  const isListingsMode = categoriesPageMode === "listings";

  const [productsLoadingStatus] = useAtom(
    isListingsMode ? listingsLoadingStatusAtom : productsLoadingStatusAtom,
  );
  const [allProducts] = useAtom(
    slider
      ? groupListingsAllProducts
      : isListingsMode
        ? allListingsAtom
        : allProductsAtom,
  );
  const [caliberCount] = useAtom(caliberCountAtom);

  const [, setBrandCaliberSEO] = useAtom(fetchBrandCaliberSEOAtom);
  const [, setProductSEO] = useAtom(fetchProductSEOAtom);
  const [, setCaliberSEO] = useAtom(fetchCaliberSEOAtom);

  const [isSEOReady, setIsSEOReady] = useState(false);

  const [caliberSEO,] = useAtom(caliberSEOAtom);
  const [productSEO] = useAtom(productSEOAtom);

  const [brandCaliberSEO] = useAtom(brandCaliberSEOAtom);

  useEffect(() => {
    const customHTML =
      productSEO?.custom_html || caliberSEO?.custom_html || null;
    setCustomHTML(customHTML);

    if (
      productSEO?.title_tag ||
      productSEO?.meta_desc ||
      caliberSEO?.title_tag ||
      caliberSEO?.meta_desc ||
      brandCaliberSEO?.title_tag ||
      brandCaliberSEO?.meta_desc
    ) {
      setIsSEOReady(true);
    }
  }, [caliberSEO, productSEO, brandCaliberSEO, setCustomHTML]);

  useEffect(() => {
    const locState = location.pathname;
    const slug = locState?.split("/").pop();
    const isAguilaPage = locState?.includes("aguila");

    const isProductPage =
      !keywords.some((key) => location.pathname.slice(1).startsWith(key)) &&
      !location.pathname.includes(calibers);

    const isCategoryPage = keywords.some((keyword) =>
      location.pathname.includes(keyword),
    );
    const isCaliberPage = location.pathname?.includes(calibers);

    if (isProductPage) {
      const pgid = slug.split("-").pop();

      setProductSEO(pgid)
    } else if (isAguilaPage) {

      setBrandCaliberSEO("aguila", calibers)
    } else if (isCaliberPage) {


      setCaliberSEO(calibers)
    } else if (isCategoryPage) {

      setBrandCaliberSEO("aguila", calibers)
    } else {

      setCaliberSEO(slug)
    }

    // eslint-disable-next-line
  }, [location.pathname]);

  const getSEOData = () => {
    const locState = location.state || locationState;
    const isProductPage = !keywords.some((key) =>
      location.pathname.startsWith(key),
    );
    const isAguilaPage = locState?.includes("aguila");
    const isCaliberPage = location.pathname?.includes(calibers);
    const isCategoryPage = location.pathname?.includes(
      "rifle-ammo" || "handgun-ammo" || "shotgun-ammo" || "rimfire-ammo",
    );

    const defaultMetaDescription =
      "Bullet Scout, your premier destination for finding the right ammunition for your firearm needs. With our comprehensive search engine, you can explore a wide array of ammunition options, ensuring you always hit your mark.";

    const seoData = {
      product: {
        title: productSEO?.title_tag || "Bullet Scout",
        metaDescription: productSEO?.meta_desc || defaultMetaDescription,
        caliber: productSEO?.caliber, 
      },
      aguila: {
        title: brandCaliberSEO?.title_tag || "Bullet Scout",
        metaDescription: brandCaliberSEO?.meta_desc || defaultMetaDescription,
        caliber: brandCaliberSEO?.caliber,
      },
      caliberPage: {
        title: caliberSEO?.title_tag || "Bullet Scout",
        metaDescription: caliberSEO?.meta_desc || defaultMetaDescription,
        caliber: caliberSEO?.caliber,
      },
      categoryPage: {
        title: brandCaliberSEO?.title_tag || "Bullet Scout",
        metaDescription: brandCaliberSEO?.meta_desc || defaultMetaDescription,
        caliber: brandCaliberSEO?.caliber,
      },
      default: {
        title: productSEO?.title_tag || "Bullet Scout",
        metaDescription: productSEO?.meta_desc || defaultMetaDescription,
        caliber: productSEO?.caliber,
      },
    };

    const currentSEOData = isAguilaPage
      ? seoData.aguila
      : isCaliberPage
        ? seoData.caliberPage
        : isProductPage
          ? seoData.product
          : isCategoryPage
            ? seoData.categoryPage
            : seoData.default;

    return currentSEOData;
  };

  return (
    <>
      {isSEOReady && (
        <Helmet
          onChangeClientState={() => {
            const metaDescriptionElement = document.querySelector(
              'meta[name="description"]',
            );

            if (metaDescriptionElement) {
              metaDescriptionElement.setAttribute(
                "content",
                getSEOData().metaDescription,
              );
            }
          }}
        >
          <link rel="canonical" href={window.location.href.split("?")[0]} />
          <title>{getSEOData().title}</title>
          <meta name="description" content={getSEOData().metaDescription} />
        </Helmet>
      )}

      {/* <Helmet
        onChangeClientState={() => {
          const metaDescriptionElement = document.querySelector(
            'meta[name="description"]',
          );

          if (metaDescriptionElement) {
            metaDescriptionElement.setAttribute(
              "content",
              getSEOData().metaDescription,
            );
          }
        }}
      >
        <link rel="canonical" href={window.location.href.split("?")[0]} />
        <title>{getSEOData().title}</title>
      </Helmet> */}

      <BreadcrumbCustom />
      {slider && <ItemInfoMobile />}
      <Flex
        maxW={{ base: "100%", xl: slider ? "100%" : "995px" }}
        flexDirection={"column"}
        w={"100%"}
        justifyContent={"space-between"}
        alignItems={"center"}
        ml={"auto"}
        mb={{ base: "23px", md: "33px" }}
      >
        <Flex
          width={"100%"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Flex flexDirection={"column"} gap={"5px"}>
            {!slider && isSEOReady && (
              <Heading
                fontSize={"22px"}
                color={getCurrentColor(colorMode, "blackC.200", "whiteC.100")}
                fontWeight={"600"}
                fontFamily={"mainFont"}
              >
                {isSEOReady && getSEOData().caliber}
              </Heading>
            )}
            {productsLoadingStatus === "loading" ? (
              <Skeleton w={"100px"} h={"20px"} />
            ) : (
              <>
                {slider ? (
                  <Flex gap={"5px"}>
                    <Box
                      w="100%"
                      maxW={{ base: "290px", xl: "420px" }}
                      display={{ base: "none", lg: "block" }}
                    >
                      <Text
                        fontSize="22px"
                        color={getCurrentColor(
                          colorMode,
                          "blackC.100",
                          "whiteC.100",
                        )}
                        fontWeight="600"
                        fontFamily="mainFont"
                      >
                        {productAttributes && productAttributes[0].title}
                      </Text>
                    </Box>
                    <Text
                      fontSize={{ base: "md", md: "lg" }}
                      color={getCurrentColor(
                        colorMode,
                        "blackC.200",
                        "whiteC.100",
                      )}
                      fontWeight={"500"}
                      fontFamily={"mainFont"}
                    >
                      {allProducts} Active offers
                    </Text>
                  </Flex>
                ) : (
                  <Text
                    fontSize={"md"}
                    color={getCurrentColor(
                      colorMode,
                      "blackC.200",
                      "whiteC.100",
                    )}
                    fontWeight={"400"}
                    fontFamily={"mainFont"}
                  >
                    {allProducts} {isListingsMode ? "results." : "Products "}
                    {!isListingsMode &&
                      caliberCount &&
                      `(${caliberCount} Listings)`}
                  </Text>
                )}
              </>
            )}
          </Flex>
          <SelectSort slider={slider} />
        </Flex>
        {!slider && (
          <Flex
            justifySelf={"flex-start"}
            width={"100%"}
            display={{ base: "flex", xl: "none" }}
            gap={2}
            mr={2}
            mt={2}
          >
            <Text
              cursor={"pointer"}
              onClick={handleCategoriesPageModeToggle}
              ml={2}
              display={"flex"}
              alignItems={"center"}
              fontWeight={500}
              fontSize={"15px"}
              color={getCurrentColor(
                colorMode,
                categoriesPageMode === "products" ? "grayC.2300" : "blackC.100",
                categoriesPageMode === "products"
                  ? "grayC.2300"
                  : "whiteC.1600",
              )}
            >
              Listings
            </Text>
            <Switch
              colorScheme="blue"
              isChecked={categoriesPageMode === "products"}
              onChange={handleCategoriesPageModeToggle}
            />
            <Text
              cursor={"pointer"}
              onClick={handleCategoriesPageModeToggle}
              display={"flex"}
              alignItems={"center"}
              fontWeight={500}
              fontSize={"15px"}
              color={getCurrentColor(
                colorMode,
                categoriesPageMode !== "products" ? "grayC.2300" : "blackC.100",
                categoriesPageMode !== "products" ? "grayC.2300" : "whiteC.100",
              )}
            >
              Products
            </Text>
          </Flex>
        )}
      </Flex>
    </>
  );
};

export default InfoOnProductsPage;
